module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mark-preview"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.marked(_vm.content))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-pad"
  }, [_vm._t("default")], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-4d5014a9!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/MarkPreview.vue
// module id = 327
// module chunks = 1 4